import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const ContractRequestModule = lazy(loadModule);

export default ContractRequestModule;
